import {
  DATA,
  SET_MESSAGE,
} from "./types";
import * as PixelService from "../services/pixel";
import { parseResponseError } from "../lib/Utils";
import {startLoading, stopLoading} from "./data";

export const createPixel = (kwargs) => async (dispatch) => {
  try {
    await PixelService.createPixel(kwargs);

    dispatch({
      type: SET_MESSAGE,
      payload: {
        info: 'New Pixel has been successfully created',
        status: '200',
      }
    });
  }
  catch(err) {

    dispatch({
      type: SET_MESSAGE,
      payload: parseResponseError(err),
    });
  }
};

export const getPixels = () => async (dispatch) => {
  try {
    const response = await PixelService.getPixels();
    const { sites: pixel_list } = response?.data?.data?.analytics || {};

    dispatch({
      type: DATA,
      payload: {
        pixel_list,
      },
    });
  }
  catch(err) {
    dispatch({
      type: SET_MESSAGE,
      payload: parseResponseError(err),
    });
  }
};

export const getPixel = (kwargs) => async (dispatch) => {
  try {
    const response = await PixelService.getPixel(kwargs);
    const { sites: pixel_list } = response?.data?.data?.analytics || {};
    const pixel = pixel_list?.[0];

    dispatch({
      type: DATA,
      payload: {
        pixel,
      },
    });
  }
  catch(err) {

    dispatch({
      type: SET_MESSAGE,
      payload: parseResponseError(err),
    });
  }
};

export const getPixelVisits = (kwargs) => async (dispatch) => {
  try {
    dispatch(startLoading());
    const response = await PixelService.getPixelVisits(kwargs);
    const { sites: pixel_list } = response?.data?.data?.analytics || {};
    const pixel = pixel_list?.[0];
    const pixel_visits = pixel?.visits;

    const reporting_data = pixel?.reporting_data;
    const reporting_enabled = pixel?.reporting_enabled;
    const has_free_trial = pixel?.has_free_trial;
    const customer_client_secret = pixel?.customer_client_secret;
    const subscription_history = pixel?.subscription_history;

    dispatch({
      type: DATA,
      payload: {
        pixel_visits,
        reporting_data,
        reporting_enabled,
        has_free_trial,
        customer_client_secret,
        subscription_history,
      },
    });
    dispatch(stopLoading());
  }
  catch(err) {
    dispatch({
      type: SET_MESSAGE,
      payload: parseResponseError(err),
    });
    dispatch(stopLoading());
  }
};

export const startFreeTrial = (kwargs) => async (dispatch) => {
  dispatch(startLoading());
  try {
    await PixelService.startFreeTrial(kwargs);
    await dispatch(getPixelVisits({ pixel_key: kwargs.pixel_key }));
    dispatch(stopLoading());
  } catch (error) {
    dispatch({
      type: SET_MESSAGE,
      payload: parseResponseError(error),
    });
    dispatch(stopLoading());
  }
}

export const updatePixel = (kwargs) => async (dispatch) => {
  try {
    await PixelService.updatePixel(kwargs);

    dispatch({
      type: SET_MESSAGE,
      payload: { info: 'Pixel has been updated', status: '200' }
    });
  }
  catch(err) {
    dispatch({
      type: SET_MESSAGE,
      payload: parseResponseError(err),
    });
  }
};

export const deletePixel = (kwargs) => async (dispatch) => {
  try {
    await PixelService.deletePixel(kwargs);

    dispatch({
      type: SET_MESSAGE,
      payload: {
        info: 'Requested Pixel has been permanently deleted',
        status: '200',
      }
    });

  }
  catch(err) {

    dispatch({
      type: SET_MESSAGE,
      payload: parseResponseError(err),
    });
  }
};
